import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import View from '@bubble-ui/primitive-view';
import { platformSelect } from '@bubble-ui/util-platform';
import { useDesignContext } from '@klarna/designtokens';
import { defaultDesignTokens } from './defaultDesignTokens';
import { getDefaultStyleSheet } from './getDefaultStyleSheet';
/**
 * Frames are a highly flexible component for displaying a wide variety of content, including information, data, how-to, next steps, and more.
 * @talebook https://bubble-ui.klarna.net/#components/frame
 */
var Frame = _ref => {
  var {
    backgroundColorToken = 'frame/background-color',
    backgroundColorTokenArgs,
    cornerRadiusToken = 'frame/corner-radius',
    children,
    id,
    paddingToken = 'frame/padding',
    testID,
    UNSAFE_props,
    UNSAFE_style
  } = _ref;
  var designContext = useDesignContext(defaultDesignTokens);
  var {
    rootStyle
  } = getDefaultStyleSheet({
    backgroundColorToken,
    backgroundColorTokenArgs,
    cornerRadiusToken,
    designContext,
    paddingToken
  });
  return /*#__PURE__*/React.createElement(View, _extends({}, platformSelect({
    native: {
      testID
    },
    default: {
      id
    }
  }), UNSAFE_props, {
    style: _objectSpread(_objectSpread({}, rootStyle), UNSAFE_style)
  }), children);
};
Frame.displayName = 'Frame';
export default Frame;
export { defaultDesignTokens };
//# sourceMappingURL=index.js.map